"use client"

import { useEffect } from "react"
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar"
import { useControlBar } from "@/components/control-bar"

export function SidebarTriggerLocked({ className }) {
  const { isInterviewActive, busy } = useControlBar()
  const { setOpen, setOpenMobile } = useSidebar()
  const locked = isInterviewActive || busy

  // Keep sidebar closed while interview is active (blocks keyboard shortcut too)
  useEffect(() => {
    if (locked) {
      setOpen(false)
      setOpenMobile(false)
    }
  }, [locked, setOpen, setOpenMobile])

  return (
    <SidebarTrigger
      className={className}
      disabled={locked}
      onClick={(e) => {
        if (locked) e.preventDefault()
      }}
    />
  )
}
